import { cn } from '../../_lib/utils'

type StatusProps = {
  children: React.ReactNode
  className?: string
  classNameCircle?: string
}

export const Status = ({ children, className, classNameCircle }: StatusProps) => {
  return (
    <div className={cn('flex w-fit items-center gap-2 px-2 py-1 text-xs font-bold', className)}>
      <div className={cn('h-2 w-2 shrink-0 rounded-full', classNameCircle)} />
      <span>{children}</span>
    </div>
  )
}
